/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateDestinationRequestMetadata
 */
export interface CreateDestinationRequestMetadata {
    /**
     * Webhook URL, must start with "https://". For `slack` destinations, this is the Slack incoming webhook URL.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    url?: string;
    /**
     * Additional headers to add when Ampersand sends a webhook message
     * @type {{ [key: string]: string; }}
     * @memberof CreateDestinationRequestMetadata
     */
    headers?: { [key: string]: string; } | null;
    /**
     * The AWS region where the Kinesis or S3 destination is hosted.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    region?: string;
    /**
     * The name of the Kinesis stream to send events to.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    streamName?: string;
    /**
     * The endpoint URL for the `kinesis` stream, or the optional custom endpoint URL for the `sqs` destination.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    endpointUrl?: string;
    /**
     * The template for the partition key (a JMESPath template). Used by `kinesis`.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    partitionKeyTemplate?: string;
    /**
     * The name of the S3 bucket to write objects to.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    bucket?: string;
    /**
     * The template for the S3 object key to use when writing objects (a JMESPath template). If omitted, the key defaults to the message timestamp followed by the message ID.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    keyTemplate?: string;
    /**
     * The S3 storage class for written objects. Defaults to STANDARD. Common values include STANDARD, STANDARD_IA, ONEZONE_IA, INTELLIGENT_TIERING, GLACIER, GLACIER_IR, and DEEP_ARCHIVE.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    storageClass?: string;
    /**
     * The username for the `clickhouse` destination.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    username?: string;
    /**
     * The destination table name (`clickhouse`, `snowflake`, `redshift`).
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    tableName?: string;
    /**
     * The database name for the `clickhouse` destination.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    database?: string;
    /**
     * The Snowflake account identifier for the `snowflake` destination.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    accountIdentifier?: string;
    /**
     * The user ID for the `snowflake` destination.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    userId?: string;
    /**
     * The database name (`snowflake`, `redshift`).
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    dbName?: string;
    /**
     * The schema name (`snowflake`, `redshift`).
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    schemaName?: string;
    /**
     * The Google Cloud project ID (`bigquery`, `pubsub`). Required for `pubsub`.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    projectId?: string;
    /**
     * The BigQuery dataset ID for the `bigquery` destination.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    datasetId?: string;
    /**
     * The BigQuery table ID for the `bigquery` destination.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    tableId?: string;
    /**
     * The Redshift Serverless workgroup name for the `redshift` destination.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    workgroupName?: string;
    /**
     * The Redshift provisioned cluster identifier for the `redshift` destination.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    clusterIdentifier?: string;
    /**
     * The database user for the `redshift` destination.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    dbUser?: string;
    /**
     * The storage account name for the `azureblob` destination.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    account?: string;
    /**
     * The blob container name for the `azureblob` destination.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    container?: string;
    /**
     * The SQS queue URL for the `sqs` destination. Required for `sqs`.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    queueUrl?: string;
    /**
     * The Pub/Sub topic ID for the `pubsub` destination. Required for `pubsub`.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    topicId?: string;
    /**
     * The AMQP server URL for the `rabbitmq` destination. Required for `rabbitmq`.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    serverUrl?: string;
    /**
     * The exchange to publish to for the `rabbitmq` destination. Required for `rabbitmq`.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    exchange?: string;
    /**
     * Whether to connect over TLS. Optional for the `rabbitmq` destination.
     * @type {boolean}
     * @memberof CreateDestinationRequestMetadata
     */
    tls?: boolean;
    /**
     * The queue or topic name for the `azureservicebus` destination. Required for `azureservicebus`.
     * @type {string}
     * @memberof CreateDestinationRequestMetadata
     */
    name?: string;
    /**
     * For warehouse destinations (`clickhouse`, `snowflake`, `bigquery`, `redshift`), the number of rows to buffer before flushing a batch. Defaults to 1000.
     * @type {number}
     * @memberof CreateDestinationRequestMetadata
     */
    batchSize?: number;
    /**
     * For warehouse destinations, the maximum number of seconds to wait before flushing a batch (whichever comes first with `batchSize`). Defaults to 30.
     * @type {number}
     * @memberof CreateDestinationRequestMetadata
     */
    maxWaitSecs?: number;
}

/**
 * Check if a given object implements the CreateDestinationRequestMetadata interface.
 */
export function instanceOfCreateDestinationRequestMetadata(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateDestinationRequestMetadataFromJSON(json: any): CreateDestinationRequestMetadata {
    return CreateDestinationRequestMetadataFromJSONTyped(json, false);
}

export function CreateDestinationRequestMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateDestinationRequestMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'url': !exists(json, 'url') ? undefined : json['url'],
        'headers': !exists(json, 'headers') ? undefined : json['headers'],
        'region': !exists(json, 'region') ? undefined : json['region'],
        'streamName': !exists(json, 'streamName') ? undefined : json['streamName'],
        'endpointUrl': !exists(json, 'endpointUrl') ? undefined : json['endpointUrl'],
        'partitionKeyTemplate': !exists(json, 'partitionKeyTemplate') ? undefined : json['partitionKeyTemplate'],
        'bucket': !exists(json, 'bucket') ? undefined : json['bucket'],
        'keyTemplate': !exists(json, 'keyTemplate') ? undefined : json['keyTemplate'],
        'storageClass': !exists(json, 'storageClass') ? undefined : json['storageClass'],
        'username': !exists(json, 'username') ? undefined : json['username'],
        'tableName': !exists(json, 'tableName') ? undefined : json['tableName'],
        'database': !exists(json, 'database') ? undefined : json['database'],
        'accountIdentifier': !exists(json, 'accountIdentifier') ? undefined : json['accountIdentifier'],
        'userId': !exists(json, 'userId') ? undefined : json['userId'],
        'dbName': !exists(json, 'dbName') ? undefined : json['dbName'],
        'schemaName': !exists(json, 'schemaName') ? undefined : json['schemaName'],
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'datasetId': !exists(json, 'datasetId') ? undefined : json['datasetId'],
        'tableId': !exists(json, 'tableId') ? undefined : json['tableId'],
        'workgroupName': !exists(json, 'workgroupName') ? undefined : json['workgroupName'],
        'clusterIdentifier': !exists(json, 'clusterIdentifier') ? undefined : json['clusterIdentifier'],
        'dbUser': !exists(json, 'dbUser') ? undefined : json['dbUser'],
        'account': !exists(json, 'account') ? undefined : json['account'],
        'container': !exists(json, 'container') ? undefined : json['container'],
        'queueUrl': !exists(json, 'queueUrl') ? undefined : json['queueUrl'],
        'topicId': !exists(json, 'topicId') ? undefined : json['topicId'],
        'serverUrl': !exists(json, 'serverUrl') ? undefined : json['serverUrl'],
        'exchange': !exists(json, 'exchange') ? undefined : json['exchange'],
        'tls': !exists(json, 'tls') ? undefined : json['tls'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'batchSize': !exists(json, 'batchSize') ? undefined : json['batchSize'],
        'maxWaitSecs': !exists(json, 'maxWaitSecs') ? undefined : json['maxWaitSecs'],
    };
}

export function CreateDestinationRequestMetadataToJSON(value?: CreateDestinationRequestMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'url': value.url,
        'headers': value.headers,
        'region': value.region,
        'streamName': value.streamName,
        'endpointUrl': value.endpointUrl,
        'partitionKeyTemplate': value.partitionKeyTemplate,
        'bucket': value.bucket,
        'keyTemplate': value.keyTemplate,
        'storageClass': value.storageClass,
        'username': value.username,
        'tableName': value.tableName,
        'database': value.database,
        'accountIdentifier': value.accountIdentifier,
        'userId': value.userId,
        'dbName': value.dbName,
        'schemaName': value.schemaName,
        'projectId': value.projectId,
        'datasetId': value.datasetId,
        'tableId': value.tableId,
        'workgroupName': value.workgroupName,
        'clusterIdentifier': value.clusterIdentifier,
        'dbUser': value.dbUser,
        'account': value.account,
        'container': value.container,
        'queueUrl': value.queueUrl,
        'topicId': value.topicId,
        'serverUrl': value.serverUrl,
        'exchange': value.exchange,
        'tls': value.tls,
        'name': value.name,
        'batchSize': value.batchSize,
        'maxWaitSecs': value.maxWaitSecs,
    };
}

